// Mirrors viz-core's vizTypeHelpers. Copy-pasted rather than imported to keep
// viz-core out of this bundle; keep the mappings in sync (canonical is REPORT).

/** Page type (or already-viz type) -> backend viz type enum. Idempotent. */
export function pageTypeToVizType(vizTypeOrPageType) {
  switch (vizTypeOrPageType) {
    case 'list':
      return 'TABLE';
    case 'board':
      return 'BOARD';
    case 'gantt':
      return 'GANTT_CHART';
    case 'report':
      return 'REPORT';
    case 'map':
      return 'MAP';
    case 'calendar':
      return 'CALENDAR';
    default:
      return vizTypeOrPageType.toUpperCase();
  }
}

/** Backend viz type (or already-page type) -> internal page type. */
export function denormalizeVizType(vizTypeOrPageType) {
  switch (vizTypeOrPageType) {
    case 'TABLE':
      return 'list';
    case 'BOARD':
      return 'board';
    case 'GANTT_CHART':
      return 'gantt';
    case 'REPORTING':
    case 'REPORT':
      return 'report';
    case 'MAP':
      return 'map';
    case 'CALENDAR':
      return 'calendar';
    default:
      return vizTypeOrPageType;
  }
}